import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import {
  RemoveSignatureFromArticlesOfAssociation,
  RemoveSignatureFromArticlesOfAssociationForm,
  toRemovalMode,
} from "./removeSignatureFromArticlesOfAssociationDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<RemoveSignatureFromArticlesOfAssociation>,
  data?: RemoveSignatureFromArticlesOfAssociation,
): RemoveSignatureFromArticlesOfAssociationForm {
  return new RemoveSignatureFromArticlesOfAssociationForm(dispatch, context, data);
}

export function handleEvent(form: RemoveSignatureFromArticlesOfAssociationForm, event: DbotEvent) {
  form.handleEvent(event);
}

export function applyForm(
  form: RemoveSignatureFromArticlesOfAssociationForm,
): RemoveSignatureFromArticlesOfAssociation {
  return {
    type: DecisionType.removeSignatureFromArticlesOfAssociation,
    paragraph: form.paragraphNumber.selected,
    removalMode: toRemovalMode(form),
  };
}

export function validate(form: RemoveSignatureFromArticlesOfAssociationForm): boolean {
  return form.validate();
}

export function isValid(form: RemoveSignatureFromArticlesOfAssociationForm): boolean {
  return form.isValid;
}

export const removeSignatureFromArticlesOfAssociationHandler: DecisionTypeHandler<
  DecisionType.removeSignatureFromArticlesOfAssociation,
  RemoveSignatureFromArticlesOfAssociation,
  RemoveSignatureFromArticlesOfAssociationForm
> = {
  type: DecisionType.removeSignatureFromArticlesOfAssociation,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
